import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import PaidHero from "@/patterns/paid-hero";

const heroStyles = css({
    "backgroundColor": "#DEEBFF",
    "backgroundImage": `var(--hero-bg-1, linear-gradient(transparent, transparent)), linear-gradient(287.15deg, #FAFBFC 0%, #DEEBFF 8.06%, #B3D4FF 35.45%, #DEEBFF 77.6%, #FAFBFC 100%)`,
    "backgroundPosition": "top right, 0 0",
    "backgroundRepeat": "no-repeat",
    "backgroundSize": "auto 100% , auto",

    "@media only screen and (min-width: 1024px)": {
        "--hero-bg-1": `url("https://wac-cdn.atlassian.com/dam/jcr:f96e5a0a-7af5-4cc6-884c-b51416e65e41/JSM_BG%20Graphics.png?cdnVersion=1276")`
    }
});

const HeroSectionPaidLpJswFeatures = () => {
    const intl = useIntl();
    return (
        <div css={heroStyles}>
            <PaidHero
                headerText={intl.formatMessage({
                    id: "JiraSoftwarePagePaidLpJswFeatures.heroHeader",
                    defaultMessage:
                        "Jira Software is the #1 software development tool used by agile teams"
                })}
                secondaryText={intl.formatMessage({
                    id: "JiraSoftwarePagePaidLpJswFeatures.heroBody",
                    defaultMessage:
                        "Trusted by 100K+ teams that plan, track, release, and manage world-class software."
                })}
                tertiaryText={intl.formatMessage({
                    id: "JiraSoftwarePagePaidLpJswFeatures.heroListHeading",
                    defaultMessage:
                        "INCLUDED IN YOUR FREE PLAN: Forever free for up to 10 users"
                })}
                image={{
                    src: "https://wac-cdn.atlassian.com/dam/jcr:6d23e95c-53a3-4fec-916b-8ecdd4589c27/JSW_Backlog_x2%202.png?cdnVersion=1276",
                    alt: intl.formatMessage({
                        id: "JiraSoftwarePagePaidLpJswFeatures.heroImageAlt",
                        defaultMessage: "Screen capture of a Jira backlog"
                    })
                }}
            />
        </div>
    );
};

export default HeroSectionPaidLpJswFeatures;
